module.exports = __webpack_public_path__ + "img/sintesis.0a04c400.svg";